/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { TokenProvider } from './TokenProvider';
import { AxiosInstaceProvider } from './AxiosProvider';
import { PermissionProvider } from './PermissionProvider';

type AuthProviderProps = React.PropsWithChildren<{
  authConfig: any,
  scopes: string[]
}>;

export const AuthProvider = (props: AuthProviderProps) => {
  const instance = React.useMemo(
    () => new PublicClientApplication(props.authConfig),
    [props.authConfig],
  );

  return (
    <MsalProvider instance={instance}>
      <TokenProvider
        scopes={props.scopes}
      >
        <AxiosInstaceProvider>
          <PermissionProvider>
            {props.children}
          </PermissionProvider>
        </AxiosInstaceProvider>
      </TokenProvider>
    </MsalProvider>
  );
};

export { useAxios } from './AxiosProvider';
export { useToken } from './TokenProvider';
export { getMsalConfig } from './AuthConfig';
export { usePermission } from './PermissionProvider';
